module.exports = __webpack_public_path__ + "img/solid_blue_eye.312fab06.svg";